//#region ------------ function shorthand -------------------------
var getByID = (element)=>{return document.getElementById(element)}
var getByClass = (element)=>{return document.querySelector('.'+element)}
var getByClassAll = (element)=>{return document.querySelectorAll('.'+element)}
//#endregion ----------------------
function contentList(lang,category_id) {

    $.ajax({
        method: 'GET',
        url:' /api/get-category?category_id='+category_id,
        cache: false,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function(res) {   
            $('#parking_menu').html("");
            let data = res[0];
            ParkingMenu(lang,data.subcategory,category_id,data.station_color);
        },
        error: function (err) {
         },
    });
}


//========================================= ที่จอดรถ mockup ====================================================//
  var activePark = getByClass('active-park');
if(activePark){
  var amountParking = getByClass('amount-parking');
  var amountParkingUnit = getByClass('amount-parking-unit');
  var btnParking = getByClass('btn-parking');
    getByClassAll('train-park').forEach((trainPark)=>{
      trainPark.addEventListener('click',(e)=>{
        let lang = e.target.getAttribute('lang-data');
        let amount = e.target.getAttribute('parking');
        let parkingID = e.target.getAttribute('parking-id');
        let id = e.target.getAttribute('data-target');
        let span = getByID(id);
        activePark.innerHTML = span.innerHTML;
        amountParking.innerHTML = amount;
        if (isNaN(amount)) {
          amountParking.classList.add('mt-3');
          amountParkingUnit.classList.add('d-none');
        } else {
          amountParking.classList.remove('mt-3');
          amountParkingUnit.classList.remove('d-none');
        }
        if (parkingID !== "") {
            $('.parking-service-menu').removeClass( "disabled" );
            $('#parking_seemore').removeClass( "d-none" );
            contentList(lang,parkingID);
        }else{
            $('.parking-service-menu').addClass( "disabled" );
            $('#parking_seemore').addClass( "d-none" );
        }
      });
    });    
}
function random_rgba() {
    var o = Math.round, r = Math.random, s = 200;
    return  o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s);
}
function ParkingMenu(lang,subcategory,category_id,station_color) { 
    let html = ""; 
    let mainStnColor = !station_color?'#0030C9':station_color;
    $('#car-parking-icon').css('--icon-bgcolor', mainStnColor);
    subcategory.forEach(subcategory => {
        let StnColor = !subcategory.station_color?random_rgba():subcategory.station_color;
        html +='<div class="col-12 col-md-6">';
        html +='<a class="btn parking-service-menu bg-light font-prompt text-start w-100 h-100 d-flex align-items-center pe-3" href="/'+lang+'/parking-service?parking_id='+category_id+'&content_select='+subcategory.id+'" type="button">';
        html += '<label class="rounded-circle bg-success text-light m-2 me-4 py-2 px-085" role="button" style="--bs-success-rgb: '+StnColor+';">';
        html +='<i class="'+subcategory.icon_frontend+' fs-5"></i>';
        html +='</label>';
        html +='<label class="fw-500 fs-1rem me-3" role="button">'+subcategory.title;
        html +='</label></a>';
        html +='</div>';
    });
    $('#parking_menu').prepend(html);
    $('#parking_seemore').attr("href", "/"+lang+"/parking-service?parking_id="+category_id);
}